import { Injectable } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { ActivityComponentComponent, ActivityComponentConverter } from '../views/activity-component/activity-component.component';
import { VariableSettingComponent, VariableSettingConverter } from '../views/variable-setting/variable-setting.component';
import { AutoActivityPropertyKeys } from '../designer/wf-cell/property-keys/AutoActivityPropertyKeys';
import { PerformerOptionsComponent, PerformerOptionsConverter } from '../views/performer/views/performer-options/performer-options.component';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()

export class AutoActivityAdapter {

  constructor(
    private uiState: ProcessDesignerUIState,
    private localPipe: WfLocalePipe
  ) {
  }

  setProperty(obj: any) {
    this.uiState.propertyData = obj.propertyData;
    this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
  }

  private setConfig(obj: any[]): ElementPropertyConfig[] {
    const propertyConfig: ElementPropertyConfig[] = [];
    if (obj) {
      obj.forEach((element: ElementPropertyConfig) => {
        this.setEntity(element.properties);
        propertyConfig.push(element);
      });
    }
    return propertyConfig;
  }
  private setEntity(obj: PropertyEntity[]) {
    if (obj && obj.length > 0) {
      obj.forEach((item: PropertyEntity) => {
        switch (item.propertyID) {
          case AutoActivityPropertyKeys.Tools: // 参与者
            item.editor = ActivityComponentComponent;
            item.converter = new ActivityComponentConverter(this.localPipe);
            item.editorParams = {
              location: 'autoActivity'
            };
            break;
          case AutoActivityPropertyKeys.variableSettings: // 变量设置
            item.editor = VariableSettingComponent;
            item.converter = new VariableSettingConverter(this.localPipe);
            break;
          case AutoActivityPropertyKeys.ParticipantOptions: // 参与者选项
            item.editor = PerformerOptionsComponent;
            item.converter = new PerformerOptionsConverter(this.localPipe);
            item.editorParams = {
              location: 'autoActivity'
            };
            break;
          default:
            break;
        }
      });
    }
  }
}
